/* Homepage enhancements are optional: every shopping link works without JS. */
(() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root = document) {
    root.querySelectorAll('[data-home-disclosure]').forEach(details => {
      if (details.dataset.disclosureReady) return;
      details.dataset.disclosureReady = 'true';
      details.addEventListener('toggle', () => {
        if (!details.open || reduced()) return;
        details.querySelector('.surprise-disclosure-body')?.animate(
          [{ opacity: 0, transform: 'translateY(-8px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 260, easing: 'cubic-bezier(.22,1,.36,1)' }
        );
      });
    });
    root.querySelectorAll('[data-home-rail]').forEach(section => {
      if (section.dataset.railReady) return;
      const track = section.querySelector('[data-rail-track]');
      const controls = section.querySelector('[data-rail-controls]');
      if (!track || !controls) return;
      section.dataset.railReady = 'true';
      const prev = controls.querySelector('[data-rail-prev]');
      const next = controls.querySelector('[data-rail-next]');
      function update() {
        const max = track.scrollWidth - track.clientWidth;
        controls.hidden = max < 2;
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= max - 2;
      }
      [prev, next].forEach((button, i) => button.addEventListener('click', () => {
        track.scrollBy({ left: (i ? 1 : -1) * track.clientWidth * .85, behavior: reduced() ? 'instant' : 'smooth' });
      }));
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    });
    root.querySelectorAll('[data-stack-picker]').forEach(section => {
      if (section.dataset.stackReady) return;
      section.dataset.stackReady = 'true';
      const buttons = section.querySelectorAll('[data-stack-option]');
      const output = section.querySelector('[data-stack-output]');
      buttons.forEach(button => button.addEventListener('click', () => {
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        output.textContent = button.dataset.stackResult;
        if (!reduced()) output.animate([{ transform: 'translateY(6px)', opacity: .5 }, { transform: 'translateY(0)', opacity: 1 }], { duration: 220, easing: 'ease-out' });
      }));
    });
    root.querySelectorAll('.home-editorial').forEach(section => {
      if (section.dataset.motionReady || reduced()) return;
      section.dataset.motionReady = 'true';
      const reveal = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) return;
        reveal.disconnect();
        if (reduced()) return;
        section.querySelectorAll('.home-editorial-intro, .home-look').forEach((item, index) => {
          item.animate([{ transform: 'translateY(16px)', opacity: .75 }, { transform: 'translateY(0)', opacity: 1 }], { duration: 380, delay: index * 60, easing: 'cubic-bezier(.22,1,.36,1)' });
        });
      }, { threshold: .15 });
      reveal.observe(section);
    });
    root.querySelectorAll('[data-editorial-video]').forEach(video => {
      if (video.dataset.ready) return;
      video.dataset.ready = 'true';
      // Playback is a deliberate tap. Stop when a shopper leaves the feature.
      const observer = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) video.pause();
      }, { threshold: .1 });
      observer.observe(video);
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
